import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';

const AdminNavigationbar = () => {
    const location = useLocation();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [name, setName] = useState("User");
    const [userRole, setUserRole] = useState(null);

    // Listen to URL changes and check login status
    useEffect(() => {
        const token = sessionStorage.getItem("token");
        const userName = sessionStorage.getItem("userName");
        const role = sessionStorage.getItem("userRole");
        
        setIsLoggedIn(!!token);
        setName(userName || "User");
        setUserRole(role);
    }, [location.pathname]); // Re-run when URL changes

    const handleLogout = () => {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("applicationId");
        sessionStorage.removeItem("userName");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("userRole");
        sessionStorage.removeItem("status");
        window.location.href = "/admin/login"; // Redirect to login page
    }

    const toggle = () => setDropdownOpen((prevState) => !prevState);
    return (
        <>
            <nav className="navbar navbar-expand-sm">
                <div className="container container_cust">
                    <div className="navbar_cust_main">
                        <a className="navbar-brand navbar_logo" href="/admin/dashboard">
                            <img src="/assets/images/logo.png" alt="BlueKraft Digital Foundation" />
                        </a>
                        {isLoggedIn && (
                            <>
                                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                                <div className="collapse navbar-collapse" id="collapsibleNavbar">
                                    <ul className="navbar-nav custom_navbar ms-auto">
                                        {/* Reviewer users only see Reviewer Dashboard */}
                                        {userRole === 'reviewer' && (
                                            <li className="nav-item">
                                                <a className="nav-link" href="/reviewer/dashboard">Reviewer Dashboard</a>
                                            </li>
                                        )}
                                        
                                        {/* Admin sees all menu items */}
                                        {userRole === 'admin' && (
                                            <>
                                                <li className="nav-item">
                                                    <a className="nav-link" href="/admin/dashboard">Dashboard</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" href="/admin/manage-users">Users</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" href="/admin/scoring-criteria">Scoring Criteria</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" href="/reviewer/dashboard">Reviewer Dashboard</a>
                                                </li>
                                            </>
                                        )}
                                        
                                        {/* Editor and Viewer see admin screens but not reviewer dashboard */}
                                        {(userRole === 'editor' || userRole === 'viewer') && (
                                            <>
                                                <li className="nav-item">
                                                    <a className="nav-link" href="/admin/dashboard">Dashboard</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" href="/admin/manage-users">Users</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" href="/admin/scoring-criteria">Scoring Criteria</a>
                                                </li>
                                            </>
                                        )}
                                    </ul>
                                </div>
                                <div className="dropdown_cust ms-3">
                                    <Dropdown className="drop_menu" isOpen={dropdownOpen} toggle={toggle}>
                                        <DropdownToggle className="card_cusr" >{name}<span className="bi bi-chevron-down"></span></DropdownToggle>
                                        <DropdownMenu className="drop_list">
                                            <DropdownItem className="dropcust_item" onClick={handleLogout}>
                                                <span className="bi bi-box-arrow-right" onClick={handleLogout}></span>
                                                Logout
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </nav>
        </>
    )
}

export default AdminNavigationbar;